import { styled, Box } from "@mui/material";

export const Divider = styled(Box)(({ theme }) => ({
  height: '1px',
  backgroundColor: '#E5E7EB',
  margin: theme.spacing(1, 0),
}));
